@if (supplierBaskets && supplierBaskets.length) {
    <div class="container-md">
        <basket-summary
            class="d-block mt-2"
            [supplierBaskets]="supplierBaskets"
            [deliveryAddress]="deliveryAddress"
            [invoiceAddress]="invoiceAddress"
            [currencyTotals]="currencyTotals"
            [resolvedPurchasingGroups]="resolvedPurchasingGroups"
            [purchasingGroupVisible]="purchasingGroupVisible"
        ></basket-summary>
        @if (isOrderCompletionAllowed() === false) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{
                        'Ihnen fehlt die Berechtigung, die Bestellung abzuschließen! Bitte kontaktieren Sie eine administrative Person.'
                            | translate
                    }}
                </div>
            </section>
        }
        @if (priceIsZero && !isOrderCreationAllowed) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{
                        '  Bestellung kann nicht ausgelöst werden, da sich ein Artikel mit einem Preis von 0,00 im Warenkorb befindet.Bitte wandeln Sie den Artikel in eine Anfrage oder löschen Sie den Artikel aus dem Warenkorb!'
                            | translate
                    }}
                </div>
            </section>
        }
        @if (!hasInvoiceAddress()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{
                        'Für den ausgewählten Buchungskreis ist keine Rechnungsadresse verfügbar. Der Warenkorb kann nicht abgeschickt werden.'
                            | translate
                    }}
                </div>
            </section>
        }
        <div class="basket-check-btn-wrapper">
            <button
                class="btn btn-outline-dark float-left"
                (click)="onClickPrevious()"
                [ngClass]="{ 'w-100': isMobile }"
            >
                {{ 'Zurück' | translate }}
            </button>
            <div class="basket-check-btn-left-wrapper">
                @if (purchaseRequisitionStatus) {
                    <button class="btn btn-outline-dark" (click)="onDemand()" [ngClass]="{ 'w-100': isMobile }">
                        {{ 'In Bedarfsmeldung wandeln' | translate }}
                    </button>
                }
                <button
                    class="btn btn-primary"
                    (click)="onCheckout()"
                    [ngClass]="{ 'w-100': isMobile }"
                    [disabled]="
                        isOrderCompletionAllowed() !== true ||
                        (priceIsZero && !isOrderCreationAllowed) ||
                        !hasInvoiceAddress()
                    "
                >
                    {{ 'Warenkorb abschicken' | translate }}
                </button>
            </div>
        </div>
    </div>
}
